// extracted by mini-css-extract-plugin
export default {"wrapper":"DoubleInputRange_wrapper__f9MZE","shimmer":"DoubleInputRange_shimmer__aeCxM"};